// gym/Gym.jsx
import React from 'react';
import { Box, Typography, Grid, Paper, Button, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  People, Assignment, Schedule, FitnessCenter,
  PointOfSale, AttachMoney, Inventory, Receipt,
  AssignmentInd, HowToReg, Store
} from '@mui/icons-material';

const Gym = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  const gymModules = [
    {
      title: 'Clients',
      description: 'Gérer les clients du gymnase',
      icon: <People sx={{ fontSize: 40 }} />,
      path: '/gym/clients',
      color: theme.palette.primary.main,
      count: 0
    },
    {
      title: 'Abonnements',
      description: 'Gérer les abonnements et forfaits',
      icon: <Assignment sx={{ fontSize: 40 }} />,
      path: '/gym/abonnements',
      color: theme.palette.secondary.main,
      count: 0
    },
    {
      title: 'Paiements',
      description: 'Suivre les paiements des clients',
      icon: <AttachMoney sx={{ fontSize: 40 }} />,
      path: '/gym/paiements',
      color: theme.palette.success.main,
      count: 0
    },
    {
      title: 'Coachs',
      description: 'Gérer les coachs sportifs',
      icon: <FitnessCenter sx={{ fontSize: 40 }} />,
      path: '/gym/coaches',
      color: theme.palette.warning.main,
      count: 0
    },
    {
      title: 'Assignations',
      description: 'Assigner des coachs aux clients',
      icon: <AssignmentInd sx={{ fontSize: 40 }} />,
      path: '/gym/assignations-coachs',
      color: theme.palette.info.main,
      count: 0
    },
    {
      title: 'Emploi du temps',
      description: 'Gérer les horaires des cours',
      icon: <Schedule sx={{ fontSize: 40 }} />,
      path: '/gym/emploi-du-temps',
      color: theme.palette.error.main,
      count: 0
    },
    {
      title: 'Présences',
      description: 'Suivre la présence des clients',
      icon: <HowToReg sx={{ fontSize: 40 }} />,
      path: '/gym/presences',
      color: theme.palette.primary.light,
      count: 0
    },
    {
      title: 'Produits Boutique',
      description: 'Gérer les produits de la boutique',
      icon: <Inventory sx={{ fontSize: 40 }} />,
      path: '/gym/boutique/produits',
      color: theme.palette.secondary.light,
      count: 0
    },
    {
      title: 'Ventes Boutique',
      description: 'Gérer les ventes de la boutique',
      icon: <PointOfSale sx={{ fontSize: 40 }} />,
      path: '/gym/boutique/ventes',
      color: theme.palette.success.light,
      count: 0
    }
  ];

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom sx={{ mb: 4, color: theme.palette.primary.main }}>
        🏋️‍♂️ Gestion de la Salle de Sport
      </Typography>
      
      <Grid container spacing={3}>
        {gymModules.map((module, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                  borderLeft: `6px solid ${module.color}`
                },
                borderLeft: `4px solid ${module.color}`
              }}
              onClick={() => navigate(module.path)}
            >
              <Box sx={{ 
                color: module.color, 
                mb: 2,
                p: 1,
                borderRadius: '50%',
                backgroundColor: `${module.color}15`
              }}>
                {module.icon}
              </Box>
              <Typography variant="h6" gutterBottom fontWeight="bold">
                {module.title}
              </Typography>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2, flexGrow: 1 }}>
                {module.description}
              </Typography>
              <Button
                variant="outlined"
                size="small"
                sx={{ 
                  mt: 'auto', 
                  borderColor: module.color, 
                  color: module.color,
                  '&:hover': {
                    backgroundColor: `${module.color}15`,
                    borderColor: module.color
                  }
                }}
              >
                Accéder →
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Gym;